/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TradingScheduleState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRADING_SCHEDULE_STATE_ENTITY_NAME = 'ixf.hours.v1.TradingSchedule';
export const ixfHoursV1TradingScheduleStateEntity = new schema.Entity<IxfHoursV1TradingScheduleState>(IXF_HOURS_V1_TRADING_SCHEDULE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TradingScheduleState) => `${entity.region}-${entity.exposure}` });

